<cp-auth-page-common>
  <div class="AuthPageControlsContainer">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.SELECT_ROLE_ON_LOGIN.SELECT_ROLE' | translate }}
    </div>

    <div class="SelectableRoles">
      @if (roles) {
        @for (role of roles; track role) {
          <div
            class="RoleItem"
            [class.CP_pointer]="!inProgress"
            (click)="onSelectRole(role.id)">
            <div class="RoleItem_radioButton"
              [ngClass]="selectedRoleId === role.id ? 'cp_radio_button_checked' : 'cp_radio_button_unchecked'">
            </div>
            <div class="CP_ellipsis CP_pointer"
              [tooltipPosition]="'bottom'"
              [pTooltip]="role.nameTranslated || role.nameCV.translations[lang]">
              {{ role.nameTranslated || role.nameCV.translations[lang] }}
            </div>
          </div>
        }
      } @else {
        @for (v of skeletons; track roleItemTrackBy(v, $index)) {
          <div
            class="RoleItem">
            <p-skeleton [height]="'1rem'" [width]="'10rem'"></p-skeleton>
          </div>
        }
      }
    </div>

    <hr>

      <div class="AuthPageControlsFooter">
        <span></span>
        <cp-button [size]="ButtonSize.MEDIUM"
          [style]="ButtonStyle.PRIMARY"
          data-cypress="selectRoleSaveBtn"
          [text]="'DESIGN_B.GLOBAL.NEXT' | translate"
          [disabled]="inProgress || !this.selectedRoleId"
          (buttonClick)="onSave()">
        </cp-button>
      </div>

    </div>
  </cp-auth-page-common>
